import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../index';

const selectUIState = (state: RootState) => state.ui;

export const selectDetailsDrawer = createSelector(
  [selectUIState],
  (uiState) => uiState.detailsDrawer
);

export const selectDetailsDrawerOpen = createSelector(
  [selectUIState],
  (uiState) => uiState.detailsDrawer.isOpen
);

export const selectDetailsDrawerTranslationId = createSelector(
  [selectUIState],
  (uiState) => uiState.detailsDrawer.translationRecordId
);

export const selectDetailsViewModel = createSelector(
  [selectUIState],
  (uiState) => uiState.detailsDrawer.viewModel
);

export const selectDeactivationDialogOpen = createSelector(
  [selectUIState],
  (uiState) => uiState.deactivationDialog.isOpen
);
